import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
  footerButtons: {
    marginTop: theme.spacing(1),
    display: "flex",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  }
}));
